import { css } from 'twind/css'

export const commonCss = css`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &:disabled {
    pointer-events: none;
    color: #9b9b9b;
  }
`

export const primaryCss = css`
  color: white;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(16px);

  &:hover {
    background-color: rgba(0, 0, 0, 0.45);
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.6);
  }

  &:disabled {
    pointer-events: none;
    background: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 0.6);
  }
`

export const secondaryCss = css`
  color: var(--blk2);
  cursor: pointer;
  background: white;
`

export const iconOnlyCss = css`
  width: 50px;
  height: 50px;
`

export const iconDropShadowCss = css`
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.3));
`
